export default __webpack_public_path__ + "img/homepage.section2.asset.462f92da.jpg";